import React from "react";
import PropTypes from "prop-types";
// import { Link } from "react-router-dom";
import "./index.scss";

const AlgorithmCard = ({ name, description }) => {
  return (
    <div className="algorithm-card">
      <p className="name">{name}</p>
      <p className="details">{description}</p>
      {/* <Link to={redirectUrl} className="link">
        Learn More
      </Link> */}
    </div>
  );
};

AlgorithmCard.propTypes = {
  name: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  // redirectUrl: PropTypes.string.isRequired,
};

export default AlgorithmCard;
